import React, { Component } from 'react';
import { getSpecificIcon } from '../../helpers/producttypes';
import { CartAdd } from '../../icons';

import './style.css';
import {
  isSize,
  getUomDisplayVal,
} from '../../helpers/attribute_util';
import { BODY_TEXT_COLOR } from '../../config/colors';

class PurchasedItem extends Component {
  getIcon = name => getSpecificIcon(name, BODY_TEXT_COLOR)

  getSize = item => parseFloat(item.weight);

  render() {
    const { item } = this.props;
    const unitOfMeasurement = getUomDisplayVal(item.unitType);
    const weight = isSize(item) ? (
      <span>
        <span> - </span>
        <span className="purchased-item-weight">
          {this.getSize(item)}
&nbsp;
          {unitOfMeasurement}
        </span>
      </span>
    ) : null;

    return (
      <div onClick={this.props.onClick} className="purchased-item-wrap">
        <div className="purchased-items">
          <div className="purchased-item">
            <div className="purchased-item-left">
              <span className="purchase-type-icon">{this.getIcon(item.type)}</span>
              <div className="purchased-item-qnt ">
                {item.quantity}
                {' '}
                <span className="purchased-item-qnt-title">qty.</span>
              </div>
            </div>
            <div className="purchased-item-right">
              <div className="purchased-item-brand">{item.brand}</div>
              <div className="purchased-item-name">{item.name}</div>
              <div className="purchased-item-size-wrapper">
                <span className="purchased-item-pricesell">
                  <sup className="purchased-dollar-sign">$</sup>
                  <span className="item-pricesell">{item.priceSell}</span>
                </span>
                {weight}
              </div>
              <div className="purchased-item-cart"><CartAdd color={this.props.color} /></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PurchasedItem;



// WEBPACK FOOTER //
// ./src/components/PurchasedItem/PurchasedItem.jsx